var __rspack_ns_object = JSON.parse('{"Age":"العمر","Sex":"الجنس","MRN":"رقم السجل الطبي","Thickness":"السُمك","Spacing":"المسافة البينية","Scanner":"الماسح"}')